(function () {
	/**
	 * Product popup "Next" navigation for modal-dialog popups on PDP.
	 * - Works with Shopify/Dawn-like <modal-dialog> + <modal-opener data-modal="#PopupModal-...">
	 * - No jQuery dependency (safe for Dawn and modern themes)
	 * - Keeps existing open/close behavior by triggering the theme's close/open mechanisms
	 * - NOW INCLUDES: Structured rows support for popup content
	 */

	const STYLE_ID = "product-popup-next-styles";
	const SWITCH_OUT_CLASS = "is-popup-switching-out";
	const SWITCH_IN_CLASS = "is-popup-switching-in";
	const SWITCH_DELAY = 0; // ms (close -> open) - disabled
	const SWITCH_ANIM = 0;  // ms - disabled

	let isSwitching = false;

	const injectStyles = () => {
		if (document.getElementById(STYLE_ID)) return;

		const style = document.createElement("style");
		style.id = STYLE_ID;
		style.textContent = `
/* =========================================================
   Product popup: Next link (PDP modal)
   ========================================================= */
.product-popup-modal__footer[hidden] { display: none !important; }

.product-popup-modal__footer {
	position: sticky;
	bottom: 0;
	margin-top: 18px;
	padding-top: 12px;
	display: flex;
	justify-content: flex-end;
	pointer-events: auto;
}

.product-popup-modal__next {
	appearance: none;
	background: transparent !important;
	border: 0 !important;
	padding: 0 !important;
	margin: 0 !important;
	cursor: pointer;
	display: inline-flex;
	align-items: baseline;
	gap: 6px;
	text-align: right;
	font: inherit;
	font-size: 16px;
	line-height: 1;
	letter-spacing: 0.01em;
	color: #AA2926;
}

.product-popup-modal__next-prefix {
	font-weight: 400;
}

.product-popup-modal__next-title {
	font-weight: 600;
}

/* Subtle "cool" detail: arrow appears only on hover/focus */
.product-popup-modal__next::after {
	content: "→";
	display: inline-block;
	opacity: 0;
	transform: translateX(-3px);
	transition: opacity .2s ease, transform .2s ease;
}

.product-popup-modal__next:hover::after,
.product-popup-modal__next:focus-visible::after {
	opacity: 1;
	transform: translateX(0);
}

/* Switch animation on inner content only (does not fight modal overlay) */
.product-popup-modal__content.${SWITCH_OUT_CLASS} {
	opacity: 0;
	transform: translateY(8px);
	transition: opacity ${SWITCH_ANIM}ms ease, transform ${SWITCH_ANIM}ms ease;
}

.product-popup-modal__content.${SWITCH_IN_CLASS} {
	opacity: 0;
	transform: translateY(8px);
}

.product-popup-modal__content.${SWITCH_IN_CLASS}.is-ready {
	opacity: 1;
	transform: translateY(0);
	transition: opacity ${SWITCH_ANIM}ms ease, transform ${SWITCH_ANIM}ms ease;
}
		

/* Do not show Next navigation inside the notify modal */
modal-dialog.notify_modal_container .product-popup-modal__footer {
	display: none !important;
}
`.trim();

		document.head.appendChild(style);
	};

	// ============================================
	// STRUCTURED ROWS SUPPORT
	// ============================================
	
	const getTemplateHtml = (id) => {
		const tpl = document.getElementById(id);
		return tpl ? (tpl.innerHTML || '').trim() : '';
	};

	const isStructuredBlock = (blockId) => {
		return !!document.getElementById('PopupStructuredBody-' + blockId);
	};

	const blockIdFromModalId = (modalId) => {
		if (!modalId) return '';
		const cleaned = modalId.replace(/^#/, '');
		if (cleaned.indexOf('PopupModal-') !== 0) return '';
		return cleaned.replace('PopupModal-', '');
	};

	const ensureTextMount = (modal) => {
		const contentInfo = modal.querySelector('.product-popup-modal__content-info') ||
			modal.querySelector('.product-popup-modal__content') ||
			modal;

		let textEl = modal.querySelector('.product-popup-modal__text');

		if (!textEl) {
			textEl = document.createElement('div');
			textEl.className = 'product-popup-modal__text rte';
			const top = modal.querySelector('.product-popup-modal__top');
			if (top && top.parentNode) {
				top.insertAdjacentElement('afterend', textEl);
			} else {
				contentInfo.appendChild(textEl);
			}
		}
		return textEl;
	};

	const moveNextBelow = (modal, textEl) => {
		const nextEl = modal.querySelector('.product-popup-modal__text_3');
		if (!nextEl) return;
		nextEl.classList.add('mp-popup-next');
		if (textEl) {
			textEl.insertAdjacentElement('afterend', nextEl);
		}
	};

	const applyStructuredRowsToModal = (modal) => {
		if (!modal || !modal.id) return;
		
		const blockId = blockIdFromModalId(modal.id);
		if (!blockId || !isStructuredBlock(blockId)) return;
		
		// Check if already applied
		if (modal.dataset.rowsApplied === blockId) return;

		const body = getTemplateHtml('PopupStructuredBody-' + blockId);
		if (!body || body.indexOf('mp-popup-row') === -1) return;

		modal.classList.add('mp-popup-rows-modal');
		modal.dataset.rowsApplied = blockId;

		const textEl = ensureTextMount(modal);
		textEl.innerHTML = body;
		textEl.classList.add('mp-popup-rows-enabled');

		const heading = getTemplateHtml('PopupStructuredHeading-' + blockId);
		if (heading) {
			const headingEl = modal.querySelector('.product-popup-modal__heading') ||
				modal.querySelector('.product-popup-modal__title') ||
				modal.querySelector('h1, h2');
			if (headingEl) headingEl.textContent = heading.replace(/<[^>]*>/g, '').trim();
		}

		moveNextBelow(modal, textEl);
	};

	const applyStructuredRowsToAllModals = (root) => {
		const templates = (root || document).querySelectorAll('template[id^="PopupStructuredBody-"]');
		
		templates.forEach((tpl) => {
			const blockId = tpl.id.replace('PopupStructuredBody-', '');
			const modalId = 'PopupModal-' + blockId;
			const modals = document.querySelectorAll('[id="' + modalId + '"]');
			modals.forEach((modal) => applyStructuredRowsToModal(modal));
		});
	};

	// ============================================
	// ORIGINAL POPUP NAVIGATION LOGIC
	// ============================================

	const getPopupLabel = (modalEl) => {
		const title =
			modalEl.querySelector(".product-popup-modal__top .product-popup-modal__title") ||
			modalEl.querySelector(".product-popup-modal__title") ||
			modalEl.querySelector("[aria-label]");
		if (!title) return "";
		// If aria-label element selected, read attribute; otherwise textContent.
		if (title.getAttribute && title.hasAttribute("aria-label")) {
			return (title.getAttribute("aria-label") || "").trim();
		}
		return (title.textContent || "").trim();
	};

	const getContextRoot = (modalEl) => {
		// Prefer the product section root to avoid collisions with other sections.
		return (
			modalEl.closest("section[id^='MainProduct-']") ||
			modalEl.closest(".shopify-section") ||
			document
		);
	};

	const getAllPopupsInContext = (contextRoot) => {
		// We intentionally exclude the "Notify me" (notification) modal from the Next chain.
		// That modal uses the same base class, but has a dedicated container class in this theme.
		return Array.from(
			contextRoot.querySelectorAll("modal-dialog.product-popup-modal[id^='PopupModal-']")
		).filter((modalEl) => {
			if (!modalEl || !modalEl.id) return false;

			// Primary exclusion (theme-specific).
			if (modalEl.classList.contains("notify_modal_container")) return false;

			// Fallback exclusion: opener button for this modal has the notify button class.
			const openerSelector = `[data-modal="#${CSS.escape(modalEl.id)}"]`;
			const opener = (contextRoot || document).querySelector(openerSelector);
			if (opener && opener.querySelector && opener.querySelector(".notify-open-button")) return false;

			return true;
		});
	};

	const closeModal = (modalEl) => {
		// Try theme method first.
		if (typeof modalEl.hide === "function") {
			modalEl.hide();
			return;
		}
		if (typeof modalEl.close === "function") {
			modalEl.close();
			return;
		}

		// Fallback: click the close button (Dawn uses .modal-close-button).
		const closeBtn =
			modalEl.querySelector(".modal-close-button") ||
			modalEl.querySelector("[id^='ModalClose-']") ||
			modalEl.querySelector("[aria-label='Close']");
		if (closeBtn) closeBtn.click();
	};

	const openModal = (targetModalId, contextRoot) => {
		const target = document.getElementById(targetModalId);
		if (!target) return;

		// Try theme method first.
		if (typeof target.show === "function") {
			try {
				target.show();
				return;
			} catch (e) {
				// Fall through to opener click.
			}
		}

		// Fallback: click matching opener (modal-opener uses data-modal="#ID").
		const selector = `[data-modal="#${CSS.escape(targetModalId)}"]`;
		const opener = (contextRoot || document).querySelector(selector);
		if (opener) {
			const btn = opener.querySelector("button, a") || opener;
			btn.click();
			return;
		}

		// Last-resort: set open attribute (may not manage body scroll/overlay in some themes).
		target.setAttribute("open", "");
	};

	const updateFootersInContext = (contextRoot) => {
		const popups = getAllPopupsInContext(contextRoot);

		popups.forEach((modalEl, index) => {
			const footer = modalEl.querySelector("[data-product-popup-footer]");
			const nextBtn = modalEl.querySelector("[data-product-popup-next]");
			const nextTitleEl = modalEl.querySelector("[data-product-popup-next-title]");

			if (!footer || !nextBtn || !nextTitleEl) return;

			if (popups.length < 2) {
				footer.setAttribute("hidden", "");
				nextTitleEl.textContent = "";
				delete nextBtn.dataset.productPopupTarget;
				return;
			}

			const nextIndex = (index + 1) % popups.length;
			const nextLabel = getPopupLabel(popups[nextIndex]);

			footer.removeAttribute("hidden");
			nextTitleEl.textContent = nextLabel || "";
			nextBtn.dataset.productPopupTarget = popups[nextIndex].id;
		});
	};

	const runSwitchAnimationOut = (modalEl) => {
		const content = modalEl.querySelector(".product-popup-modal__content");
		if (!content) return;
		content.classList.add(SWITCH_OUT_CLASS);
		window.setTimeout(() => content.classList.remove(SWITCH_OUT_CLASS), SWITCH_ANIM + 30);
	};

	const runSwitchAnimationIn = (modalEl) => {
		const content = modalEl.querySelector(".product-popup-modal__content");
		if (!content) return;
		content.classList.add(SWITCH_IN_CLASS);
		// Force a paint so the transition can run.
		content.getBoundingClientRect();
		content.classList.add("is-ready");
		window.setTimeout(() => {
			content.classList.remove(SWITCH_IN_CLASS);
			content.classList.remove("is-ready");
		}, SWITCH_ANIM + 30);
	};

	const init = (root = document) => {
		injectStyles();

		// Update all contexts in the provided root.
		const contexts = new Set();

		Array.from(root.querySelectorAll("modal-dialog.product-popup-modal")).forEach((modalEl) => {
			contexts.add(getContextRoot(modalEl));
		});

		if (contexts.size === 0) {
			// Fallback: update in document in case modal lives outside root.
			updateFootersInContext(document);
		} else {
			contexts.forEach((ctx) => updateFootersInContext(ctx));
		}

		// ============================================
		// APPLY STRUCTURED ROWS ON INIT
		// ============================================
		applyStructuredRowsToAllModals(root);
	};

	// Click handler (event delegation).
	document.addEventListener("click", function (e) {
		const btn = e.target && e.target.closest ? e.target.closest("[data-product-popup-next]") : null;
		if (!btn) return;

		e.preventDefault();
		if (isSwitching) return;

		const currentModal = btn.closest("modal-dialog");
		if (!currentModal) return;

		const contextRoot = getContextRoot(currentModal);
		const targetId = btn.dataset.productPopupTarget;

		if (!targetId) return;

		isSwitching = true;

		runSwitchAnimationOut(currentModal);
		closeModal(currentModal);

		window.setTimeout(() => {
			openModal(targetId, contextRoot);

			const nextModal = document.getElementById(targetId);
			if (nextModal) {
				// ============================================
				// APPLY STRUCTURED ROWS AFTER OPENING NEW MODAL
				// ============================================
				applyStructuredRowsToModal(nextModal);

				// Give the theme a moment to render/lock focus then animate.
				window.setTimeout(() => {
					runSwitchAnimationIn(nextModal);
					const focusEl = nextModal.querySelector(".product-popup-modal__content");
					if (focusEl && typeof focusEl.focus === "function") focusEl.focus();
				}, 60);
			}

			window.setTimeout(() => {
				isSwitching = false;
			}, SWITCH_ANIM + 120);
		}, SWITCH_DELAY);
	});

	// ============================================
	// HANDLE DIRECT POPUP OPENS (not via Next button)
	// ============================================
	document.addEventListener("click", function (e) {
		const opener = e.target && e.target.closest ? e.target.closest("[data-modal]") : null;
		if (!opener) return;
		
		const modalId = opener.getAttribute("data-modal");
		if (!modalId || modalId.indexOf("#PopupModal-") !== 0) return;
		
		const cleanId = modalId.replace(/^#/, '');
		
		// Apply structured rows after a short delay to let modal open
		window.setTimeout(() => {
			const modal = document.getElementById(cleanId);
			if (modal) {
				applyStructuredRowsToModal(modal);
			}
		}, 50);
	}, true);

	document.addEventListener("DOMContentLoaded", function () {
		init(document);

		// Shopify section reload support.
		document.addEventListener("shopify:section:load", function (evt) {
			init(evt && evt.target ? evt.target : document);
		});
	});

	// Also run immediately in case the script is loaded after DOMContentLoaded.
	if (document.readyState === "interactive" || document.readyState === "complete") {
		init(document);
	}
})();